export default __webpack_public_path__ + "static/main_desktop_v3_hy-75d60d45d94f2b7f494336dbdf8d86e2.mp4";